import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Layout from "../Components/Layout";
import EmployeeList from "../Section/EmployeeList";
import AddEmployee from "../Section/AddEmployee";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState("dashboard");
  const [showAddEmployeeModal, setShowAddEmployeeModal] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [showDownloadAttendModal, setShowDownloadAttendModal] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");

  const handleShowAddEmployee = () => setShowAddEmployeeModal(true);
  const handleShowDownloadModal = () => setShowDownloadModal(true);
  const handleShowDownloadAttendModal = () => setShowDownloadAttendModal(true);

  const handleCloseModal = () => {
    setShowAddEmployeeModal(false);
    setShowDownloadModal(false);
    setShowDownloadAttendModal(false);
    setRefreshKey((prevKey) => prevKey + 1);
  };

  const handleDownloadTimeSheet = async () => {
    if (!year || !month) {
      toast.error("Please select both Year and Month");
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Unauthorized: Token not found");
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/attendance/monthly-timesheets/by-name?year=${year}&month=${month}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "*/*",
          },
          responseType: "blob",
        }
      );

      if (response.status === 200) {
        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", `TimeSheet_${year}_${month}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        toast.success("File downloaded successfully");
        handleCloseModal();
      }
    } catch (error) {
      console.error("Download Error:", error);
      let rawMessage = error?.response?.data?.message;

      if (typeof rawMessage !== "string") {
        rawMessage = "Something went wrong!";
      }

      toast.error(
        rawMessage.length > 100 ? rawMessage.slice(0, 100) + "..." : rawMessage
      );
    }
  };

    const handleDownloadAttendance = async () => {
    if (!year || !month) {
      toast.error("Please select both Year and Month");
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Unauthorized: Token not found");
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/attendance/export/monthly-attendance?year=${year}&month=${month}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "*/*",
          },
          responseType: "blob",
        }
      );

      if (response.status === 200) {
        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", `TimeSheet_${year}_${month}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        toast.success("File downloaded successfully");
        handleCloseModal();
      }
    } catch (error) {
      console.error("Download Error:", error);
      let rawMessage = error?.response?.data?.message;

      if (typeof rawMessage !== "string") {
        rawMessage = "Something went wrong!";
      }

      toast.error(
        rawMessage.length > 100 ? rawMessage.slice(0, 100) + "..." : rawMessage
      );
    }
  };
  return (
    <Layout activeTab={activeTab} setActiveTab={setActiveTab}>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        limit={3}
        style={{ zIndex: 9999 }}
      />

     
<div className="d-flex justify-content-between align-item-center">
   <h2 className=''>Admin Dashboard Overview</h2>
          <Button onClick={handleShowDownloadAttendModal}>Download Attendance</Button>

</div>
      <div className="d-flex justify-content-between mt-3">
        <Button onClick={handleShowAddEmployee}>Add Employee</Button>
        <Button onClick={handleShowDownloadModal}>Download TimeSheet</Button>
      </div>

      <div className="row g-4">
        <EmployeeList refreshKey={refreshKey} />
      </div>

      {/* Add Employee Modal */}
      <Modal
        show={showAddEmployeeModal}
        onHide={handleCloseModal}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Employee</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddEmployee handleCloseModal={handleCloseModal} />
        </Modal.Body>
      </Modal>

      {/* Download TimeSheet Modal */}
      <Modal
        show={showDownloadModal}
        onHide={handleCloseModal}
        centered
        size="sm"
      >
        <Modal.Header closeButton>
          <Modal.Title>Download TimeSheet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formYear">
              <Form.Label>Year</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter year e.g. 2025"
                value={year}
                onChange={(e) => setYear(e.target.value)}
              />
            </Form.Group>

            <Form.Group controlId="formMonth" className="mt-3">
              <Form.Label>Month</Form.Label>
              <Form.Select
                value={month}
                onChange={(e) => setMonth(e.target.value)}
              >
                <option value="">Select Month</option>
                {[
                  "January",
                  "February",
                  "March",
                  "April",
                  "May",
                  "June",
                  "July",
                  "August",
                  "September",
                  "October",
                  "November",
                  "December",
                ].map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Button className="mt-4" onClick={handleDownloadTimeSheet}>
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
        {/* Download Attendance Sheet */}
        <Modal
        show={showDownloadAttendModal}
        onHide={handleCloseModal}
        centered
        size="sm"
      >
        <Modal.Header closeButton>
          <Modal.Title>Download Attendance</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formYear">
              <Form.Label>Year</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter year e.g. 2025"
                value={year}
                onChange={(e) => setYear(e.target.value)}
              />
            </Form.Group>

            <Form.Group controlId="formMonth" className="mt-3">
              <Form.Label>Month</Form.Label>
              <Form.Select
                value={month}
                onChange={(e) => setMonth(e.target.value)}
              >
                <option value="">Select Month</option>
                {[
                  "January",
                  "February",
                  "March",
                  "April",
                  "May",
                  "June",
                  "July",
                  "August",
                  "September",
                  "October",
                  "November",
                  "December",
                ].map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Button className="mt-4" onClick={handleDownloadAttendance}>
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </Layout>
  );
};

export default AdminDashboard;
